import { render } from "./TransfertGroupRecursive.vue?vue&type=template&id=12b46861"
import script from "./TransfertGroupRecursive.vue?vue&type=script&lang=js"
export * from "./TransfertGroupRecursive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__